import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import Container from '@mui/material/Container';

const NavBar = () => {
    const location = useLocation();

    const navItems = [
        { label: 'Generate', path: '/' },
        { label: 'FAQ', path: '/faq' },
        { label: 'About', path: '/about' }
    ];

    return (
        <AppBar position="static" color="primary" elevation={3}>
            <Container maxWidth="sm" sx={{ textAlign: 'center', py: 1 }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    IBAN Generator
                </Typography>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    {navItems.map(item => (
                        <Button
                            key={item.path}
                            component={Link}
                            to={item.path}
                            color="inherit"
                            sx={{
                                textTransform: 'none',
                                fontWeight: location.pathname === item.path ? 'bold' : 'normal',
                                borderBottom: location.pathname === item.path ? '2px solid white' : 'none',
                                borderRadius: 0,
                            }}
                        >
                            {item.label}
                        </Button>
                    ))}
                </Box>
            </Toolbar>
            </Container>
        </AppBar>
    );
};

export default NavBar;
